import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import {
  OrganizationChoicePageComponent
} from '~/organizer/components/pages/organization-choice-page/organization-choice-page.component';
import {
  OrganizerFedLandingPageComponent
} from '~/organizer/components/pages/fed-landing-page/fed-landing-page.component';
import { ParamethorModule } from '~/paramethor/paramethor.module';

import { OrganizerRoutingModule } from './organizer-routing.module';
import { OrganizerSharedModule } from './shared/shared.module';

/**
 * Organizer/Admin website part
 */
@NgModule({
  declarations: [
    OrganizerFedLandingPageComponent,
    OrganizationChoicePageComponent,
  ],
  imports: [
    AuthModule,
    CommonModule,
    CoreModule,
    OrganizerRoutingModule,
    ComponentModule,
    OrganizerSharedModule,
    ReactiveFormsModule,
    FormsModule,
    ParamethorModule,
  ],
})
export class OrganizerModule {}
